import * as React from 'react';
import { ClickAwayListener } from '@mui/material';
import { Grow } from '@mui/material';
import { Paper } from '@mui/material';
import { Popper } from '@mui/material';
import { MenuItem } from '@mui/material';
import { MenuList } from '@mui/material';
import { ArrowDownTwo } from '../icons';
import Typography from '../typography/typography';
import { ButtonProps } from '@mui/material';

export interface ITitleDropdownMenuOption {
	label: string | JSX.Element;
	callback: (event?: any, index?: number) => void;
	color?: string;
}

interface TitleDropdownButtonProps extends ButtonProps {
	children: React.ReactNode;
	options: ITitleDropdownMenuOption[];
	isMenuThirdItemDisabled: boolean;
	currentTitle: string;
}

const TitleDropdownButton: React.FC<TitleDropdownButtonProps> = ({
	children,
	options,
	isMenuThirdItemDisabled,
	currentTitle = '',
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: Event) => {
		if (
			anchorRef.current &&
			anchorRef.current.contains(event.target as HTMLElement)
		) {
			return;
		}

		setOpen(false);
	};

	return (
		<React.Fragment>
			<div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }} ref={anchorRef}>
				<Typography type="h3" weight="medium" color="theme.secondary.1000">
					{children}
				</Typography>
				<div
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label='select merge strategy'
					aria-haspopup='menu'
					style={{ minWidth: 'unset !important', cursor: 'pointer' }}
					onClick={handleToggle}
				>
					<ArrowDownTwo fontSize='small' />
				</div>
			</div>
			<Popper
				sx={{
					zIndex: 1
				}}
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin:
								placement === 'bottom' ? 'center top' : 'center bottom'
						}}>
						<Paper elevation={0} sx={{ border: '1px solid', borderRadius: 2, borderColor: 'theme.grey.200'}}>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem>
									{options.map((option, index) => (
										<MenuItem
											key={index}
											disabled={isMenuThirdItemDisabled ? false : (index === 2)}
											selected={currentTitle?.trim() === option.label?.trim()}
											onClick={(event) => {
												option.callback(event, index);
												handleToggle();
											}}>
											<Typography
												type='s4'
												color={
													option.color ? option.color : 'theme.secondary.1000'
												}>
												{option.label}
											</Typography>
										</MenuItem>
									))}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</React.Fragment>
	);
};

export default TitleDropdownButton;
